import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-46b4aad8")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-2 h4 text-center" }
const _hoisted_3 = { class: "col-3 h4 text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "col-2" }
const _hoisted_6 = ["id", "placeholder", "onUpdate:modelValue"]
const _hoisted_7 = { class: "col-2" }
const _hoisted_8 = ["id", "placeholder", "onUpdate:modelValue"]
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = ["id", "placeholder", "onUpdate:modelValue"]
const _hoisted_11 = { class: "col-2" }
const _hoisted_12 = { class: "input-group mb-2" }
const _hoisted_13 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_14 = { class: "input-group-append" }
const _hoisted_15 = ["onClick", "title"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-lock" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "col-3 p-0 d-flex justify-content-between" }
const _hoisted_19 = ["title", "onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-save" }, null, -1)
const _hoisted_21 = ["title", "onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-redo" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["title", "onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortCaret = _resolveComponent("SortCaret")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: "col-2 h4 text-center",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sort('firstname')))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t("messages.first name")) + " ", 1),
        _createVNode(_component_SortCaret, {
          inactive: _ctx.currentSort!=='firstname',
          dir: _ctx.currentSortDir
        }, null, 8, ["inactive", "dir"])
      ]),
      _createElementVNode("a", {
        class: "col-2 h4 text-center",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sort('lastname')))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t("messages.Surname")) + " ", 1),
        _createVNode(_component_SortCaret, {
          inactive: _ctx.currentSort!=='lastname',
          dir: _ctx.currentSortDir
        }, null, 8, ["inactive", "dir"])
      ]),
      _createElementVNode("a", {
        class: "col-3 h4 text-center",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort('email')))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t("messages.e-mail")) + " ", 1),
        _createVNode(_component_SortCaret, {
          inactive: _ctx.currentSort!=='email',
          dir: _ctx.currentSortDir
        }, null, 8, ["inactive", "dir"])
      ]),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("messages.password")), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("messages.Actions")), 1)
    ]),
    _hoisted_4,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedUsers, (user) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "form-inline row",
        key: user.id,
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control mb-2 w-100",
            id: 'firstname'+user.id,
            placeholder: _ctx.$t('messages.first name'),
            name: "firstname",
            "onUpdate:modelValue": ($event: any) => (user.firstname = $event)
          }, null, 8, _hoisted_6), [
            [_vModelText, user.firstname]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control mb-2 w-100",
            id: 'lastname'+user.id,
            placeholder: _ctx.$t('messages.Surname'),
            name: "lastname",
            "onUpdate:modelValue": ($event: any) => (user.lastname = $event)
          }, null, 8, _hoisted_8), [
            [_vModelText, user.lastname]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control mb-2 w-100",
            id: 'email'+user.id,
            placeholder: _ctx.$t('messages.e-mail'),
            name: "email",
            "onUpdate:modelValue": ($event: any) => (user.email = $event)
          }, null, 8, _hoisted_10), [
            [_vModelText, user.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": ($event: any) => (user.password = $event),
              name: "password",
              placeholder: _ctx.$t('messages.password')
            }, null, 8, _hoisted_13), [
              [_vModelText, user.password]
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "btn btn-primary px-3",
                onClick: ($event: any) => (_ctx.generateNewPassword(user.id)),
                title: _ctx.$t('messages.generate new password')
              }, _hoisted_17, 8, _hoisted_15)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "btn btn-primary mb-2",
            title: user.id === -1 ? 'Benutzer erstellen ' : 'Speichern',
            onClick: ($event: any) => (_ctx.saveUser(user))
          }, [
            _hoisted_20,
            _createTextVNode(" " + _toDisplayString(user.id === -1 ? _ctx.$t("messages.Create") : ''), 1)
          ], 8, _hoisted_19),
          _createElementVNode("button", {
            class: "btn btn-secondary mb-2",
            title: _ctx.$t('messages.reset values'),
            onClick: ($event: any) => (_ctx.refreshUser(user))
          }, _hoisted_23, 8, _hoisted_21),
          (user.id !== -1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-red mb-2",
                title: _ctx.$t('messages.delete user'),
                onClick: ($event: any) => (_ctx.deleteUser(user))
              }, [
                _hoisted_25,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.Extinguish")), 1)
              ], 8, _hoisted_24))
            : _createCommentVNode("", true)
        ])
      ], 32))
    }), 128))
  ], 64))
}